import { render } from "./componentheader.vue?vue&type=template&id=70d29a08&scoped=true"
import script from "./componentheader.vue?vue&type=script&lang=js"
export * from "./componentheader.vue?vue&type=script&lang=js"

import "./componentheader.vue?vue&type=style&index=0&id=70d29a08&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d29a08"]])

export default __exports__